// extracted by mini-css-extract-plugin
module.exports = {"Map":"maperOld_Map__OgJ72","MapBlock":"maperOld_MapBlock__D72IK","Link":"maperOld_Link__nmoBR"};